








import { Component, Vue } from "vue-property-decorator";
import TransparenciaDecretos from "@/components/Web/TransparenciaDecretos.vue";

@Component({
  components: {
    TransparenciaDecretos
  },
  meta: {
    // sets document title
    title: "Transparencia - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí la información acerca de las transparencias."
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class TramitesView extends Vue {
  private mounted() {
    document.title = "Transparencias - Ilustre Municipalidad de Punta Arenas";
  }
}
